import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button, Container, Form, FormGroup, Input, Label, Row, Col } from 'reactstrap';
import * as actions from '../actions/Project';
import Breadcrumb from '../components/AdminBreadcrumb';

class Project extends React.Component {

    handleSave = () => {
      const { name, code } = this.props.project.toJS();
        if (name && code) {
            this.props.actions.updateProject(this.props.project);
            this.props.history.push('/projects');
        }
    }


    handleChange = (e) => {
        const { name, value } = e.target;
        this.props.actions.setField(name, value);
    }

    render() {

        const { name, code, projectId } = this.props.project.toJS();
        return (
            <Container>
                <div style={{ paddingBottom: '10px' }}>
                    <Breadcrumb history={this.props.history} />
                </div>
                <Form>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>Name:</Label>
                                <Input name='name' invalid={!name} onChange={this.handleChange} required value={name || ''} />
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label>Code:</Label>
                                <Input name='code' invalid={!code} onChange={this.handleChange} required value={code || ''} readonly={!projectId} />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button type="submit" className={'float-right'} disabled={!name || ! code} onClick={this.handleSave}>Save</Button>
                        </Col>
                    </Row>
                </Form >
            </Container>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        project: state.Project
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators({ ...actions }, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(Project);